<template>
  <button :type="type" class="btn btn-primary btn-block" :disabled="isDisabled">
    <slot></slot>
  </button>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';

defineProps({
  type: {
    required: false,
    type: String as PropType<'submit' | 'reset' | 'button'>,
    default: 'button',
  },
  isDisabled: {
    required: false,
    type: Boolean,
    default: false,
  },
});
</script>
